// Times as people read them: "14s ago", "3 h ago", "Oct 1".
const MIN = 60_000;

export function ago(iso: string | null | undefined, now: number = Date.now()): string {
  if (!iso) return 'never';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  const d = Math.max(0, now - t);
  if (d < MIN) return `${Math.round(d / 1000)}s ago`;
  if (d < 60 * MIN) return `${Math.round(d / MIN)} min ago`;
  if (d < 24 * 60 * MIN) return `${Math.round(d / (60 * MIN))} h ago`;
  return day(iso);
}

export function day(iso: string): string {
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return iso;
  return t.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export function clock(iso: string): string {
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return '';
  return t.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
}

/** How long since `iso`: "40 s", "9 min", "2 h 31 min", "3 d". */
export function duration(iso: string | null | undefined, now: number = Date.now()): string {
  if (!iso) return '';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  const d = Math.max(0, now - t);
  if (d < MIN) return `${Math.round(d / 1000)} s`;
  if (d < 60 * MIN) return `${Math.floor(d / MIN)} min`;
  if (d < 24 * 60 * MIN) {
    const h = Math.floor(d / (60 * MIN));
    const m = Math.floor((d % (60 * MIN)) / MIN);
    return m ? `${h} h ${m} min` : `${h} h`;
  }
  return `${Math.floor(d / (24 * 60 * MIN))} d`;
}
